import { render, staticRenderFns } from "./PublicationBreakdownModal.vue?vue&type=template&id=f2141a34&"
import script from "./PublicationBreakdownModal.vue?vue&type=script&lang=js&"
export * from "./PublicationBreakdownModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports